import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

// import DRAWERHERO from "../../assets/images/request-access.png";
import COMMON from "../../assets/images/commonNew.png";
import { ReactComponent as IWA } from "../../assets/images/input-whatsapp.svg";
const ismobile = window.innerWidth <= 768;

export default function RegisterForm({
  data = {},
  setData = () => {},
  registerHandler = () => {},
  verifying = false,
}) {
  const [error, setError] = useState({ name: false, phone: false });
  const navigate = useNavigate();
  return (
    <div
      className="common"
      style={{
        backgroundImage: `url(${COMMON})`,
        height: "100%",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        className="request-hero"
        style={{
          width: "100%",
          height: "45%",
        }}
      >
        {/* <ImageLoader
          src={DRAWERHERO}
          style={{
            objectFit: "contain",
            // paddingTop: "1.5rem",
            width: "100%",
            height: "100%",
          }}
        /> */}
      </div>
      <div
        style={{
          padding: "30px 0",
          // backgroundColor: "#121212",
          borderRadius: "20px 20px 0 0",
          display: "flex",
          flexDirection: "column",
          color: "#FFFFFF",
        }}
      >
        <span
          className="request-main-text"
          style={{
            paddingTop: 0,
            fontSize: ismobile ? 20 : 22,
            textTransform: "capitalize",
          }}
        >
          Get your card now !
        </span>
        <TextField
          label="Name"
          className="form-input"
          value={data.name}
          onChange={(e) => {
            setError({ ...error, name: e.target.value ? false : true });
            setData({ ...data, name: e.target.value });
          }}
          error={error.name}
          helperText={error.name ? "Please enter your name" : " "}
          // disabled={verifying}
          style={{ margin: "0.5rem 1.5rem" }}
          placeholder="Ex. Abc Xyz"
        />
        <TextField
          className="form-input"
          placeholder="Ex. 9876543210"
          InputProps={{
            startAdornment: (
              <span
                className="request-input-prefix"
                style={{ display: "flex", alignItems: "center" }}
              >
                <IWA
                  style={{
                    height: "1.4em",
                    width: "1.4em",
                    marginRight: "0.5rem",
                  }}
                />
                +91
              </span>
            ),
          }}
          inputProps={{ maxLength: 10 }}
          label="Phone"
          value={data.phone}
          onChange={(e) => {
            setError({ ...error, phone: !/^\d{10}$/.test(e.target.value) });
            setData({ ...data, phone: e.target.value });
          }}
          error={error.phone}
          helperText={error.phone ? "Please enter valid phone number" : " "}
          // disabled={verifying}
          style={{ margin: "0.5rem 1.5rem" }}
        />
        <Button
          id="step-2-onboarding"
          onClick={registerHandler}
          style={{
            margin: "0.5rem 1.5rem",
            padding: "16px 0",
            fontSize: "1em",
            background:
              !data.name ||
              !data.phone ||
              error.phone ||
              error.name ||
              verifying
                ? "#383838"
                : "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color:
              !data.name ||
              !data.phone ||
              error.phone ||
              error.name ||
              verifying
                ? "#232323"
                : "#FF4A01",
          }}
          size="large"
          variant="contained"
          disabled={
            !data.name || !data.phone || error.phone || error.name || verifying
          }
        >
          {verifying ? "Submitting..." : "Continue"}
        </Button>
        <p
          style={{
            textAlign: "center",
            color: "#FFFFFF",
            fontSize: "13.0493px",
            margin: "0 2rem 1.5rem",
          }}
        >
          By continuing you agree to{" "}
          <b
            style={{ cursor: "pointer", color: "#FF7F4C" }}
            onClick={() => navigate("/terms")}
          >
            Terms & conditions <br />
          </b>{" "}
          &{" "}
          <b
            style={{ cursor: "pointer", color: "#FF7F4C" }}
            onClick={() => navigate("/privacy")}
          >
            Privacy policy
          </b>
        </p>
      </div>
    </div>
  );
}
